import { Component, OnInit } from '@angular/core';
import { DataLoginModel } from 'src/app/aplicaciones-modulos/epp/models/dataLoginModel';

@Component({
  selector: 'app-home-sstma',
  templateUrl: './home-sstma.component.html',
  styleUrls: ['./home-sstma.component.css']
})
export class HomeSstmaComponent implements OnInit {

  dataUsuario: DataLoginModel;

  constructor() { }

  ngOnInit() {
    this.dataUsuario = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
  }

}
